import { useRouter } from 'next/router'
import { VFC } from 'react'
import { FeedbackModalDetailIcon } from 'src/assets/svgs'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { Layout } from 'src/compositions/Messages/Modals/styles'
import { Link } from 'src/elements/Link'
import { FeedbackRoom } from 'src/models/Room'
import {
  _feedback_orange,
  _messagebuttonbg,
  _profilehrborder,
  truewhite,
  white,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { membersArticlePage, MESSAGES } from 'src/utils/routes'
import styled from 'styled-components'
import { FeedbackCard } from './FeedbackCard'

const FeedbackModalContent: VFC<
  ModalProps & {
    feedbackRooms: FeedbackRoom[]
    mutate: () => void
    feedbackArticleId?: number
  }
> = ({ close, feedbackRooms, mutate, feedbackArticleId }) => {
  const router = useRouter()
  const onClickHeader = () => {
    router.push(MESSAGES)
    close()
  }
  return (
    <FeedbackLayout>
      <HeaderLeft onClick={() => onClickHeader()}>
        <h1>メッセージ画面へ</h1>
      </HeaderLeft>
      <Header>
        <h3>お知らせ</h3>
        <p>
          この度、利用いただいているユーザーの皆様の声を受け、
          <br />
          2024年10月より決裁者さま同士のアポイントに対しての相互評価サービス
          <br />
          「アポイント・評価(β版)」をリニューアルリリースさせていただく運びとなりました。
          <br />
          変更点や詳細については下記の「詳細はこちら」リンクより、ご確認ください
        </p>
        {feedbackArticleId && (
          <HeaderLink href={membersArticlePage(feedbackArticleId)}>
            <FeedbackModalDetailIcon />
            詳細はこちら
          </HeaderLink>
        )}
        <br />
        <br />
        <br />
        <h3>つながった会員へのフィードバックをお願いします</h3>
      </Header>
      <FeedbackCardsDiv>
        {feedbackRooms.map((room) => (
          <FeedbackCard key={room.uniqueId} item={room} mutate={mutate} />
        ))}
      </FeedbackCardsDiv>
    </FeedbackLayout>
  )
}

export const FeedbackModal = asModal(FeedbackModalContent, {
  scrollable: true,
})

const FeedbackCardsDiv = styled.div`
  padding: 16px;
  ${FeedbackCard} {
    :not(:first-child) {
      margin-top: 32px;
    }
  }
`
const FeedbackLayout = styled(Layout)`
  padding: 0 128px 64px;
  text-align: center;
  max-height: 80vh;
  overflow-y: auto;
  > p {
    margin-top: 16px;
    font-weight: ${fontWeightBold};
  }
  ${FeedbackCardsDiv} {
    margin-top: 16px;
  }
  position: relative;
`
const Header = styled.div`
  background-color: ${truewhite};
  padding: 80px 0 16px;
  text-align: center;
  border-bottom: 1px solid ${_profilehrborder};
  p {
    font-weight: ${fontWeightBold};
  }
`
const HeaderLink = styled(Link)`
  text-align: center;
  color: ${_feedback_orange};
  padding-top: 12px;
  display: inline-block;

  svg {
    margin-right: 4px;
  }
`
const HeaderLeft = styled.a`
  position: absolute;
  left: 20px;
  top: 20px;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: ${fontWeightBold};
  color: ${white};
  text-align: center;
  cursor: pointer;
  background-color: ${_messagebuttonbg};
`
